import { render, staticRenderFns } from "./documentSet.vue?vue&type=template&id=4289d7b2&scoped=true"
import script from "./documentSet.vue?vue&type=script&lang=js"
export * from "./documentSet.vue?vue&type=script&lang=js"
import style0 from "./documentSet.vue?vue&type=style&index=0&id=4289d7b2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4289d7b2",
  null
  
)

export default component.exports